import { IconSize } from 'assets/icons/icon-sizes';
import ExternalLinkIcon from 'assets/icons/navigation/ExternalLinkIcon';
import { BodyRegular, FlexCol, NavLinkNoWrap } from 'components/Elements';
import useGetRequest from 'hooks/useGetRequest';
import { TERMS_URL } from 'lib/_api-helpers';
import styled from 'styled-components';
import { sizes, theme } from 'theme';
import strings from '../../strings/strings.json';

export default function TermsAndVersion() {
    const { version } = require('../../../package.json');
    const { data: backendVersion, called, loading } = useGetRequest<string>('version');

    if (!called) return <></>;
    if (loading) return <></>;

    return (
        <TermsAndVersionContainer>
            <TermsLink>
                <NavLinkNoWrap to={TERMS_URL} target="_blank" $inverted>
                    {strings.profilePage.termsOfUse}
                    <ExternalLinkIcon size={IconSize.MEDIUM} colour={theme.textColourInverted} />
                </NavLinkNoWrap>
            </TermsLink>
            {version && backendVersion && (
                <FlexCol>
                    <BodyRegular $inverted>
                        {strings.versionInformation.frontEndText}
                        {version}
                    </BodyRegular>
                    <BodyRegular $inverted>
                        {strings.versionInformation.backEndText}
                        {backendVersion}
                    </BodyRegular>
                </FlexCol>
            )}
        </TermsAndVersionContainer>
    );
}

const TermsLink = styled.div`
    display: flex;
    align-items: center;
    gap: ${sizes.spacingSm};
`;

const TermsAndVersionContainer = styled(FlexCol)`
    gap: ${sizes.spacingSm};
`;
